/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commerical BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-10-14 11:07:49
 *
 *******************************************************/
// @flow
import _ from 'lodash';
import React, { Component } from 'react';
import { Banner, Link } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import CustomDropZone from 'src/components/views/common/custom-dropzone';
import { VERIFY_MESSAGE_SYNONYM } from 'src/constants/message';
import SampleFile from 'src/assets/files/synonyms sample data.csv';

type Props = {
  fileContentErrorCode: string
};

type ComposedProps = Props & WithI18nProps;

class Upload extends Component<ComposedProps> {
  render() {
    const { i18n, fileContentErrorCode } = this.props;

    return (
      <React.Fragment>
        {!_.isEmpty(fileContentErrorCode) && (
          <div style={{ paddingBottom: '1.25rem', borderTop: '3px solid #de3618' }}>
            <Banner
              title={i18n.translate('AdminHTML.Synonym.Import.uploadError')}
              status="critical">
              <p>
                {}
                {VERIFY_MESSAGE_SYNONYM[fileContentErrorCode]
                  ? i18n.translate(VERIFY_MESSAGE_SYNONYM[fileContentErrorCode])
                  : ''}
              </p>
            </Banner>
          </div>
        )}

        <div>{i18n.translate('AdminHTML.Synonym.Import.uploadContent')}</div>

        {/* Choose file*/}
        <CustomDropZone fileTypes={['text/csv']} onSelectFile={this.props.onSelectFile} />

        <div style={{ paddingTop: '1.25rem' }}>
          {i18n.translate('AdminHTML.Synonym.Import.download', {
            t1: (
              <Link url={SampleFile}>{i18n.translate('AdminHTML.Synonym.Import.download_t1')}</Link>
            )
          })}
        </div>
      </React.Fragment>
    );
  }
}

export default withI18n()(Upload);
